import styled from "@emotion/styled";
import { css } from "@emotion/react";
import { base } from "next/dist/build/webpack/config/blocks/base";

export const ProductsPage = styled.div`
  .description {
    background-color: #e6e6e7;
    margin-top: -80px;
    p {
      font-weight: 400;
      font-size: 18px;
      line-height: 36px;
      color: #000000;
      max-width: 1200px;
      margin: 0 auto;
      padding: 80px 16px 100px;
    }
  }
  .productsList {
    margin-top: -45px;
  }

  ${({ theme }) => ({
    [theme.breakpoints.down("md")]: {},
  })};
`;

export const Filter = styled.div`
  border: 1px solid #e6e6e7;
  border-radius: 8px;
  background: #ffffff;
  margin-bottom: 60px;
  padding: 20px 30px;
  display: grid;
  grid-template-columns: 1fr 5px 1fr 5px 1fr 5px 1fr;
  grid-auto-rows: 1fr;
  grid-column-gap: 30px;
  grid-row-gap: 0;
  .loader {
    margin: 20px 0;
  }
  ${({ theme }) => ({
    [theme.breakpoints.down("md")]: {
      gridTemplateColumns: " 1fr 1fr",
      gridRowGap: 30,
      "& > div": {
        maxWidth: "100%",
      },
      ".MuiDivider-root": {
        display: "none",
      },
    },
    [theme.breakpoints.down("sm")]: {
      gridTemplateColumns: " 1fr",
      gridRowGap: 30,
    },
  })};
`;

export const FilterItem = styled.div`
  flex: 1 1 auto;
  max-width: 250px;
  .MuiSelect-select {
    padding: 8px;
  }
  .MuiOutlinedInput-notchedOutline {
    border: none;
  }
`;

export const ProductsItem = styled.div`
  border: 1px solid #e6e6e7;
  background-color: #ffffff;
  border-radius: 8px;
  margin-bottom: 10px;
  padding: 15px;

  transition: all 250ms ease-in-out;
  &:hover {
    /*border-color: #17479e;*/
    box-shadow: 0 0 10px 0 #8d8e91;
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  .title {
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    text-transform: capitalize;
    color: #808285;
  }
  .text {
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
    text-transform: capitalize;
    color: #000000;
    ${props =>
      props.locale === "fa"
        ? css`
            direction: rtl;
            text-align: left;
          `
        : ""}
  }
  .imageWrapper {
    width: 60px;
    height: 60px;
    border-radius: 4px;
  }
  &.typeColumn {
    gap: 16px;
    flex-direction: row;
    justify-content: flex-start;
  }
  ${props =>
    props.locale === "fa"
      ? css`
          direction: rtl;
          text-align: left;
        `
      : ""}
  ${({ theme }) => ({
    [theme.breakpoints.down("md")]: {
      flexDirection: "row",
      justifyContent: "space-between",
      columnGap: 24,
      direction: "unset",
      "&.typeColumn ": {
        [Column]: {
          flexDirection: "column",
        },
      },
      "& .text.app": {
        textAlign: "right",
      },
    },
  })};
`;

export const ProductItemPage = styled.div`
  margin-top: -80px;
  h1 {
    /*font-family: Inter, "Open Sans", Roboto, sans-serif;*/
    font-weight: 700;
    font-size: 44px;
    line-height: 53px;
    color: #000000;
    margin-bottom: 30px;

    ${props =>
      props.locale === "fa"
        ? css`
            direction: rtl;
            text-align: left;
          `
        : ""}
  }
  .orderBtn {
    padding: 15px 30px;
    a {
      display: inline-flex;
      font-size: 16px;
    }
  }
  .MuiDivider-root {
    border-color: #e6e6e7;
    margin-bottom: 30px;
    margin-top: 30px;
  }
  .MuiTab-root {
    padding: 15px;
    font-weight: 500;
    font-size: 16px;
    line-height: 34px;
    text-transform: capitalize;
  }
  div[id^="simple-tabpanel"] {
    .MuiBox-root {
      padding-right: 0;
      padding-left: 0;
      padding-top: 40px;
    }
  }
  .other {
    font-weight: 700;
    font-size: 24px;
    line-height: 29px;
    color: #000000;
    margin-bottom: 30px;
  }
  .detailsBoxInfo {
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    column-gap: 6px;
    ${props =>
      props.locale === "fa"
        ? css`
            &:first-of-type {
              span:last-of-type {
                direction: rtl;
              }
            }
          `
        : ""}
  }
  .content * {
    font-family: inherit !important;
  }
`;
export const ProductInfoWrapper = styled.div`
  background: #fafafa;
  padding: 115px 0 80px;
  /*product gallery custom styles 🔽*/
  .swiper {
    width: 100%;
    margin-left: auto;
    margin-right: auto;
  }

  .swiper-slide {
    background-size: cover;
    background-position: center;
  }

  .view-selected-image-swiper {
    height: 400px;
    width: 100%;
    border-radius: 20px;
  }

  .swiper-thumbnails-row {
    height: 20%;
    box-sizing: border-box;
    padding: 10px 0;
  }

  .swiper-thumbnails-row .swiper-slide {
    width: 25%;
    height: 90px;
    opacity: 0.4;
    border-radius: 8px;
    overflow: hidden;
  }

  .swiper-thumbnails-row .swiper-slide-thumb-active {
    opacity: 1;
  }

  .swiper-slide img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .swiper-button-next:after,
  .swiper-button-prev:after {
    font-size: 30px;
  }

  ${({ theme }) => ({
    [theme.breakpoints.down("md")]: {
      paddingTop: "100px",
      ".view-selected-image-swiper": {
        height: 310,
      },
      ".swiper-thumbnails-row .swiper-slide {": {
        height: 60,
      },
    },
  })}
`;

export const BrodCrampWrapper = styled.p`
  font-family: Inter, "Open Sans", Roboto, sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  text-transform: capitalize;
  color: #000000;
  margin-bottom: 10px;
  span {
    color: #808285;
  }
  ${props =>
    props.locale === "fa"
      ? css`
          direction: rtl;
          text-align: left;
        `
      : ""}

  ${({ theme }) => ({
    [theme.breakpoints.down("sm")]: {
      marginBottom: 20,
      marginTop: -30,
    },
  })}
`;

export const Details = styled.span`
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: #808285;
  &.info {
    color: #000000;
    ${props =>
      props.locale === "fa"
        ? css`
            direction: rtl;
            text-align: left;
          `
        : ""}
  }
  a {
    color: #17479e;
    text-transform: uppercase;
  }
`;

export const Description = styled.p`
  font-weight: 400;
  font-size: 18px;
  line-height: 34px;
  color: #000000;
  margin: 5px 0 15px;
`;

export const AdditionalInformation = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  justify-content: flex-start;
  ${Column} {
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    padding: 10px;
    &:not(:last-of-type) {
      border-bottom: 1px solid #f2f2f3;
    }
    h3 {
      flex: 0 0 180px;
    }
  }

  ${({ theme }) => ({
    [theme.breakpoints.down("sm")]: {
      [Column]: {
        justifyContent: "space-between",
        h3: {
          flexBasis: 100,
        },
        p: {
          textAlign: "right",
        },
      },
    },
  })}
`;

export const DownloadRow = styled.div`
  background: #ffffff;
  border: 1px solid #e6e6e7;
  border-radius: 8px;
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  &:not(:last-of-type) {
    margin-bottom: 10px;
  }
  p {
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
    text-transform: capitalize;
    color: #000000;
  }
  button {
    background: #f2f2f3;
    border-radius: 54px;
    padding: 0;
    overflow: hidden;
    a {
      font-weight: 500;
      font-size: 14px;
      border-radius: 54px;
      display: inline-flex;
      width: 100%;
      height: 100%;
      padding: 8px 25px;
      text-transform: capitalize;
    }
  }
`;

export const ProductTypeReadMoreBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background: #f9f9f9;
  border-radius: 15px;
  padding: 30px;
  color: #000000;
  margin-bottom: 40px;
  .title {
    font-weight: 700;
    font-size: 24px;
    line-height: 29px;
    margin-bottom: 20px;
  }
  .content {
    font-weight: 400;
    font-size: 18px;
    line-height: 34px;
    margin-bottom: 15px;
  }
  button {
    padding: 12px 20px;
  }
`;

export const ProductPageReadMore = styled.div`
  .p1,
  .p2,
  .t2 {
    margin-bottom: 40px;
  }
  .mainTitle {
    margin-bottom: 30px;
    text-align: center;
  }
  .MuiDivider-root {
    margin-top: 120px;
    margin-bottom: 40px;
    ${({ theme }) => ({
      [theme.breakpoints.down("md")]: {
        margin: "60px 0 40px",
      },
    })}
  }
  .ulWrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 20px 0;
    gap: 30px;
    flex-wrap: wrap;
    li:not(:last-of-type) {
      margin-bottom: 25px;
    }
  }
`;

export const H1 = styled.h1`
  font-weight: 800;
  font-size: clamp(26px, 3vw, 34px);
  line-height: 61px;
  color: #000000;
`;

export const ProductsBox = styled.div`
  border: 1px solid #e6e6e7;
  background-color: #ffffff;
  border-radius: 8px;
  padding: 15px;
  height: 100%;

  display: flex;
  align-items: center;

  transition: all 250ms ease-in-out;
  &:hover {
    border-color: #17479e;
  }
`;

export const FlowChart = styled.div`
  background: #fafafa;
  padding: 80px 0;
  margin: 80px 0;
  ${({ theme }) => ({
    [theme.breakpoints.down("md")]: {
      padding: "60px 0",
      margin: "60px 0",
    },
  })}
`;

export const H3 = styled.h3`
  font-weight: 700;
  font-size: 20px;
  line-height: 35px;
  color: #000000;
  margin-bottom: 30px;
`;
export const OrderBox = styled.div`
  background: #f9f9f9;
  border-radius: 8px;
  padding: 20px;
`;
